export default {
	data() {
		return {
			requiredRefs: [],
		}
	},
	computed: {
		requiredFields() {
			return []
		}
	},
	methods: {
		validateRequiredFields() {
			this._.forEach(this.requiredFields, function (field) {
				let ref = field['ref'] ? field['ref'] : field['key'] + 'ref'
				if (!this.entity[field['key']]) {
					this.setFieldInvalid(ref, true, this.$gettext('Zadejte') + " " + field['name'])
				} else {
					this.setFieldInvalid(ref)
				}
			}.bind(this))
		},
		setFieldInvalid(ref, value = false, text = null) {
			this.$refs[ref].setForcedInvalid(value, text)
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/required-fields.js